import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { UtilService } from 'app/_services/util.service';

class TradingProcedureSettingsComponentCtrl implements ng.IController {
    private settings: TsoSecondarySettingsDto;
    private authenticatedUser: LoginResult;

    constructor(
        private utilService: UtilService,
        private growl: Growl,
        private errorHandler: ErrorHandler,
        private TransmissionSystemOperator: TransmissionSystemOperatorResource
    ) {}

    $onInit() {}

    private onTradingProcedureSupportChange(
        tradingProcedure: ProcedureType
    ): void {
        const atLeastOneTradingProcedureIsSupported =
            this.utilService
                .values(this.settings.tradingProcedureSupport)
                .indexOf(true) !== -1;

        if (!atLeastOneTradingProcedureIsSupported) {
            this.growl.show(
                'Please select at least one trading procedure.',
                'danger'
            );
            this.settings.tradingProcedureSupport[tradingProcedure] = true;
            return;
        }

        this.TransmissionSystemOperator.saveTradingProcedureSupport(
            { id: this.authenticatedUser.referenceId },
            this.settings.tradingProcedureSupport,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }
}

angular.module('app').component('pkpTradingProcedureSettings', {
    controller: TradingProcedureSettingsComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/trading-procedure-settings.component.html'),
    bindings: {
        settings: '=',
        authenticatedUser: '='
    }
});
